import React from "react";
import SectionContainer from "../../../components/sectionContainer/sectionContainer";
import { useSelector } from "react-redux";

export const withToggle = (Component) => {
  function NewComponent({
    title,
    commonProps: { toolTipContent, toolTipId },
    commonProps,
    dataPointProps
  }) {
    const previousToggleValue = useSelector((state) => state.membershipUnits.previousToggleValue);

    return previousToggleValue ? (
      <div className="content__el">
        <SectionContainer title={title} toolTip={toolTipContent} toolTipId={toolTipId}>
          <Component {...commonProps} {...dataPointProps} />
        </SectionContainer>
      </div>
    ) : null;
  }

  return NewComponent;
};
